import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './catalog-section-table-header.scss?inline';

export default class SotbitCatalogSectionTableHeader extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    render() {
        return html` <slot name="cell"></slot> `;
    }
}
